<template>
    <div>
        <div v-if="dealerDetailsLoading">
            <div class="loading"></div>
        </div>
        <div v-else>
            <h5>{{ $t("Service point") }}: <small>{{ dealerService.company_name }}</small></h5>
            <b-form @submit.prevent="createAppointment()">
                <div class="alert alert-danger" role="alert" v-if="response && response.variant=='danger'">
                    <div v-for="(msg, index) in response.errmsg" :key="index" class="my-1">
                        <i class="fa fa-exclamation mr-2"></i>{{ msg }}
                    </div>
                </div>
                <!-- <div v-if="response.variant=='danger'">
                    <bootstrap-alert
                        :variant="response.variant" 
                        :msg="response.message" 
                        :errorMsg="response.errmsg" 
                    />
                </div> -->

                <div class="d-flex rounded p-2 ">
                    <b-calendar
                        v-model="appointmentDate"
                        :hide-header="true"
                        :min="min(dealerService)"
                        :no-highlight-today="true"
                        class="border justify-content-center"
                        :date-disabled-fn="dateDisabled"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :locale=" (this.currentLang == 'en_GB') ? 'en' : 'fi' "
                        :start-weekday="1">
                    </b-calendar>
                    <!-- <div> -->
                    <div v-if="unavailableLoading" class="loading"></div>
                    <span v-if="loadAllowedTimes"><div class="loading"></div></span>
                    <span v-else class="time-slots scrollbar-light-blue">
                        <b-form-group>
                            <b-form-radio-group
                                    id="btn-radios-3"
                                    v-model="timeSlot"
                                    :options="allowedTimeOptions"
                                    buttons
                                    stacked
                                    name="sel-time-slot"
                            >
                            <b-form-invalid-feedback>{{ $t("Please select one") }}</b-form-invalid-feedback>
                            </b-form-radio-group>
                        </b-form-group>
                    </span>
                </div>
            </b-form>
            <div class="modal-footer justify-content-center border-0" v-if="showProceedButton">
                <b-button @click="createAppointment()"
                          class="text-uppercase bg-green pt-2 pb-2 pl-3 rounded pr-3 color-white"
                          :disabled="disableProceed"
                          v-if="!proceedLoading"
                >
                    <b-spinner v-if="disableProceed" small></b-spinner>
                    {{ $t("Proceed to Order information") }}
                </b-button>
                <span v-if="proceedLoading"><span class="fa fa-spinner fa-spin"></span>{{ $t('Updating details') }}</span>
            </div>
        </div>
        <!-- <div v-else class="loading"></div> -->
    </div>
</template>
<style scoped>
    /* .fixed-header {
        background-color: rgba(0,0,0,1);
        padding: 10px 0px;
    } */
</style>
<script>
    import {mapGetters, mapActions} from "vuex";

    export default {
        name: 'appointment-popup',
        props: {
            'dealerService': {
                type: Object,
                default: {}
            },
            'availableDays': {
                type: Array,
                default: []
            },
            'allowedTimes': {
                type: Array,
                default: []
            },
            'localDealersList' : {
                type : Array
            },
            'showProceedButton' : {
              type : Boolean,
              default : true
            }
        },
        data() {
            return {
                disableProceed: false,
                appointmentDate: null,
                loadAllowedTimes: false,
                allowedTimeOptions: []
            }
        },
        computed: {
            ...mapGetters('app', ['currentLang']),
            ...mapGetters('cart', ['rimSizes', 'cartId', 'cartProducts', 'cartDetails']),
            ...mapGetters('appointments', ['isShow', 'response', 'appointmentLoading', 'unavailableLoading', 'unavailableSlots', 'unavailableDays', 'holidays']),
            ...mapGetters('services', ['cartServiceLoading']),
            ...mapGetters('dealerservices', ['dealerDetails', 'dealerDetailsLoading']),
            ...mapGetters('order', ['proceedLoading']),
        },
        created() {
            this.fetchDealerDetails(this.dealerService.dealer_id)
        },
        watch: {
            appointmentDate: {
                immediate: true,
                handler(newValue) {
                    this.appointmentDate = newValue
                    if (newValue != '' && newValue != null) {
                        this.allowedTimeOptions = this.getAllowedTimes(this.dealerService)
                    }

                },
            },
            timeSlot: {
                immediate: true,
                handler(newValue) {
                    this.timeSlot = newValue
                },
            },
            allowedTimes: {
                immediate: true,
                deep: true,
                handler(newValue) {
                    this.allowedTimes = newValue
                },
            },
            allowedTimeOptions: {
                immediate: true,
                deep: true,
                handler(newValue) {
                    this.allowedTimeOptions = newValue
                },
            }
        },
        beforeDestroy: function () {
            this.resetError()
        },
        // beforeCreate() {
        //     this.resetError()
        // },
        methods: {
            ...mapActions('services', ['addServicesInCart']),
            ...mapActions('appointments', ['addAppointment', 'showError', 'resetError', 'getUnavailableSlotList']),
            ...mapActions('dealerservices', ['fetchDealerDetails']),
            ...mapActions('cart', ['getAllCartProducts']),
            ...mapActions('cart_right_sidebar', ['csSetName', 'csSetEmail', 'csSetPhone', 'csSetDate', 'csSetAddress', 'csSetCity', 'csSetTime', 'csSetDealerId', 'csSetTimeSlots', 'csSaveDealerToLocalStorage', 'csSetIsWithService']),
            ...mapActions('order', ['confirmOrderWithPaytrail']),
            ...mapActions('search_dealer', ['setSelectedServicePoint']),
            min(dealerservice) {
                let days = this.availableDays
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                // 15th two months prior
                const minDate = today
                let weekdays = [];
                if (this.currentLang != 'en_GB') {
                    weekdays = [
                        'Sunnuntai',
                        'Maanantai',
                        'Tiistai',
                        'Keskiviikko',
                        'Torstai',
                        'Perjantai',
                        'Lauantai'
                    ];
                } else {
                    weekdays = [
                        'Sunday',
                        'Monday',
                        'Tuesday',
                        'Wednesday',
                        'Thursday',
                        'Friday',
                        'Saturday'
                    ];
                }
                let count = 0, length = dealerservice.min_skip_day + 2 , month, dm, tempDate;
                // Order Monday first possibility to booking time on Thrusday
                // Order Tuesday first possibility to booking time on Friday  
                // Order Wednesday first possibility to book time on Monday  
                // Order Thursday first possibility to book time on Tuesday
                // Order Friday first possibility to book time on Wednesday
                // Order weekend first possibility to book time on Wednesday
                // Order public holiday first possibility to book time on 3th working day
                for (let i=1; i<length; i++) {
                    minDate.setDate(minDate.getDate() + 1)
                    // check for weekend
                    while (_.indexOf(days, weekdays[minDate.getDay()]) == -1) {
                        minDate.setDate(minDate.getDate() + 1)
                        // check for holiday
                        while (this.holidays.includes(tempDate)) {
                            minDate.setDate(minDate.getDate() + 1)
                            month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                            dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                            tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                        }
                    }
                    month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                    dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                    tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                    // check for holiday
                    while (this.holidays.includes(tempDate)) {
                        minDate.setDate(minDate.getDate() + 1)
                        // check for weekend
                        while (_.indexOf(days, weekdays[minDate.getDay()]) == -1) {
                            minDate.setDate(minDate.getDate() + 1)
                        }
                        month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                        dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                        tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                    }
                }

                if (!this.appointmentDate || this.appointmentDate == null) {
                    let month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                    let dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                    this.appointmentDate = minDate.getFullYear() + '-' + month + '-' + dm
                }

                //this.allowedTimeOptions = this.getAllowedTimes(this.allowedTimes, this.appointmentDate)
                return minDate;
            },
            dateDisabled(ymd, date) {
                let weekdays = []
                if (this.currentLang != 'en_GB') {
                    weekdays = [
                        'Sunnuntai',
                        'Maanantai',
                        'Tiistai',
                        'Keskiviikko',
                        'Torstai',
                        'Perjantai',
                        'Lauantai'
                    ];
                } else {
                    weekdays = [
                        'Sunday',
                        'Monday',
                        'Tuesday',
                        'Wednesday',
                        'Thursday',
                        'Friday',
                        'Saturday'
                    ];
                }

                const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' }) 
                const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date) 
                let dateFromated = `${year}-${month}-${day}`;

                if(_.indexOf(this.unavailableDays, dateFromated) !== -1){
                    console.log('blocked');
                    return true;
                }
                let d = new Date();
                if (_.indexOf(this.availableDays, weekdays[date.getDay()]) < 0) {
                    return true
                } else if ((date.getDate() < d.getDate() && date.getMonth() == d.getMonth() && date.getYear() == d.getYear())
                    || (date.getMonth() < d.getMonth() && date.getYear() <= d.getYear()
                        || date.getYear() < d.getYear() || this.holidays.includes(dateFromated))
                ) {
                    return true
                } else {
                    return false;
                }
            },
            max(dealerservice) {
                let days = this.availableDays
                let weekdays = [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ];
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                // 15th in two months
                const maxDate = new Date(today)
                let count = 0;
                while (_.indexOf(days, weekdays[maxDate.getDay()]) >= 0 && count < 3) {
                    maxDate.setDate(maxDate.getDate() + 1)
                    count++;
                }
                return maxDate;
            },
            onReset() {
                this.appointmentDate = null
                this.timeSlot = null
            },
            async createAppointment() {
                var setflag = true;
                this.errors = [];
                if (!(this.appointmentDate)) {
                    setflag = false;
                    if (this.currentLang == 'en_GB') {
                        this.errors.push('Select an appointment date');
                    } else {
                        this.errors.push('Varauksen päivämäärä');
                    }
                }
                if (!(this.timeSlot)) {
                    setflag = false;
                    if (this.currentLang == 'en_GB') {
                        this.errors.push('Select time slot');
                    } else {
                        this.errors.push('Varauksen aika');
                    }
                }
                if (setflag) {
                    this.resetError();
                    let arrSelectedServices = []
                    let serviceIds = []
                    for (let sel in this.dealerService.services) {
                        if (this.dealerService.services && this.dealerService.services[sel]) {
                            arrSelectedServices.push({
                                'service_id': this.dealerService.services[sel].service_id,
                                'type': this.dealerService.services[sel].rim_size ? 'price_per_quantity' : 'single_cost'
                            })
                            serviceIds.push(this.dealerService.services[sel].service_id)
                        }
                    }
                    let cartServices = {
                        'cartId': this.cartId,
                        'services': arrSelectedServices,
                        'cartProducts': this.cartProducts
                    }
                    let appointment = {
                        'dealer_id': this.dealerService.dealer_id,
                        'cart_id': this.cartId,
                        'service_ids': '[' + _.join(_.uniq(serviceIds), [',']) + ']'
                    }
                    appointment.schedule_date = this.appointmentDate
                    let start = this.timeSlot.split(':')
                    appointment.start_time = this.timeSlot
                    if (parseInt(start[1]) == 30) {
                        appointment.end_time = (parseInt(start[0]) + 1) + ":00"
                    } else {
                        appointment.end_time = start[0] + ":30"
                    }
                    this.csSetRightSidebarDealerData(appointment);/* return;*/

                    // Set appointment for cache
                    localStorage.setItem("appointment", JSON.stringify(appointment));
                    this.addAppointment(appointment);
                    await this.confirmOrderWithPaytrail({}).then(() => {
                      this.getAllCartProducts();
                      this.$emit('hidepopup');
                      $('.modal-backdrop').remove();
                      this.onReset();
                      this.$router.push({
                        path: '/cart/user-info', params: {}, replace: true
                      });
                    }).catch(() => {
                      this.$emit('hidepopup');
                      this.$emit('goToError');
                    });

                } else {
                    this.disableProceed = false;
                    this.showError({'msg': '', 'errors': this.errors});
                }
            },
            async getAllowedTimes(dealerservice) {
                if (this.appointmentDate !== "" && this.dealerService.dealer_id) {
                    this.loadAllowedTimes = true
                    let availableTime = []
                    let unavailableTimeSlots = []
                    let weekdays = [];
                    if (this.currentLang != 'en_GB') {
                        weekdays = [
                            'Sunnuntai',
                            'Maanantai',
                            'Tiistai',
                            'Keskiviikko',
                            'Torstai',
                            'Perjantai',
                            'Lauantai'
                        ];
                    } else {
                        weekdays = [
                            'Sunday',
                            'Monday',
                            'Tuesday',
                            'Wednesday',
                            'Thursday',
                            'Friday',
                            'Saturday'
                        ];
                    }
                    let apptDate = new Date(this.appointmentDate)
                    let slots = []
                    let day = weekdays[apptDate.getDay()]
                    await this.getUnavailableSlotList(dealerservice.dealer_id)
                        .then((res) => {
                            if (this.unavailableSlots) {
                                unavailableTimeSlots = []
                                for (let slot in this.unavailableSlots) {
                                    let scheduleDate = this.unavailableSlots[slot].schedule_date
                                    if (_.indexOf(_.keys(unavailableTimeSlots), scheduleDate) === -1) {
                                        unavailableTimeSlots[scheduleDate] = []
                                    }
                                    unavailableTimeSlots[scheduleDate].push(this.unavailableSlots[slot].start_time)
                                }
                            }
                            
                            for (let timeSlot in dealerservice.time_slots) {
                                if (weekdays[apptDate.getDay()] == dealerservice.time_slots[timeSlot].day) {
                                    let startTime = dealerservice.time_slots[timeSlot].start_time
                                    let endTime = dealerservice.time_slots[timeSlot].end_time
                                    let start = startTime.split(':')
                                    let end = endTime.split(':')
                                    let i = start[0];
                                    for (i = parseInt(start[0]); i <= parseInt(end[0]); i++) {
                                        let hour = i
                                        if (i < 10) {
                                            hour = "0" + i
                                        }
                                        if (parseInt(start[1]) >= parseInt("00")
                                            && parseInt(start[1]) < parseInt("30")) {
                                            slots.push(hour + ':' + '00')
                                        }
                                        if (i < parseInt(end[0]) ||
                                            (parseInt(end[0]) == i && parseInt(end[1]) >= parseInt("30"))) {
                                            slots.push(hour + ':' + '30')
                                        }
                                    }
                                }
                            }
                        })

                    this.loadAllowedTimes = false
                    
                    if (unavailableTimeSlots && _.keys(unavailableTimeSlots).length > 0
                        && _.indexOf(_.keys(unavailableTimeSlots), this.appointmentDate) > -1) {
                        this.allowedTimeOptions = [];
                        for (let slot in slots) {
                            if (_.indexOf(unavailableTimeSlots[this.appointmentDate], slots[slot] + ":00") === -1) {

                                this.allowedTimeOptions.push(slots[slot])
                            }
                        }
                    } else {
                        this.allowedTimeOptions = slots
                    }

                    var breakStartTime = this.dealerDetails.break_start_time
                    var breakEndTime = this.dealerDetails.break_end_time

                    if(breakStartTime && breakEndTime){
                        this.allowedTimeOptions = this.allowedTimeOptions.filter(function(slotObject){
                            let slotTime = slotObject+":00"

                            if(breakStartTime == slotTime || (slotTime > breakStartTime && slotTime < breakEndTime)){
                                return false
                            }
                            return true
                        })
                    }

                    this.loadAllowedTimes = false
                    return this.allowedTimeOptions
                }
            },
            csSetRightSidebarDealerData(appointment_data) {
                const dealer = this.localDealersList.find(dealerItem => dealerItem.id === appointment_data.dealer_id);
                this.csSetName('( '+ dealer.company_name + ' ) '+dealer.dealer_first_name + dealer.dealer_last_name);
                this.csSetEmail(dealer.dealer_email);
                this.csSetPhone(dealer.contact_number);
                this.csSetAddress(dealer.address_line_1 + ' ' + (dealer.address_line_2 || ''));
                this.csSetCity(dealer.city);
                this.csSetDate(appointment_data.schedule_date);
                this.csSetTime(appointment_data.start_time + ' TO ' + appointment_data.end_time);
                this.csSetDealerId(appointment_data.dealer_id)
                this.csSetTimeSlots(dealer.time_slots)
                this.csSaveDealerToLocalStorage();
                this.csSetIsWithService(true);
                this.setSelectedServicePoint(dealer);
                localStorage.setItem("SearchedSelectedServicePoint", JSON.stringify(dealer));
            }
        }
    }
</script>